<template>
  <PTabs class="s-company-wall-details-portfolio" scrollable :value="value">
    <PTabList>
      <PTab v-if="portfolio.projects.length" :value="panelValues.projects">
        {{ tr("main_site.company_wall.projects", { count: totalAlbumImages }) }}
      </PTab>
      <PTab v-if="portfolio.video" :value="panelValues.video">
        {{ tr("main_site.company_wall.video") }}
      </PTab>
    </PTabList>
    <PTabPanels>
      <PTabPanel :value="panelValues.projects">
        <SAlbums :albums="portfolio.projects" />
      </PTabPanel>
      <PTabPanel :value="panelValues.video">
        <div class="s-company-wall-details-portfolio__video">
          <div
            v-if="portfolio.video?.title || portfolio.video?.description"
            class="s-company-wall-details-portfolio__video__content"
          >
            <div
              v-if="portfolio.video?.title"
              class="s-company-wall-details-portfolio__video__content__title"
            >
              {{ portfolio.video?.title }}
            </div>
            <div
              v-if="portfolio.video?.description"
              class="s-company-wall-details-portfolio__video__content__description"
            >
              {{ portfolio.video?.description }}
            </div>
          </div>
          <div class="s-company-wall-details-portfolio__video__video">
            <a :href="portfolio.video?.link" target="_blank">
              <img
                :alt="tr('main_site.company_wall.video')"
                loading="lazy"
                :src="portfolio.video?.cover"
              />
              <div class="s-company-wall-details-portfolio__video__video__icon">
                <div
                  class="s-company-wall-details-portfolio__video__video__icon__container"
                >
                  <div
                    class="s-company-wall-details-portfolio__video__video__icon__container__circle"
                  >
                    <i class="fa-solid fa-play" />
                  </div>
                </div>
              </div>
            </a>
          </div>
        </div>
      </PTabPanel>
    </PTabPanels>
  </PTabs>
</template>

<script setup lang="ts">
import { computed, ref } from "vue";

import {
  PTab,
  PTabList,
  PTabPanel,
  PTabPanels,
  PTabs,
  SAlbums,
} from "@solvari/components";
import { useI18nMainSiteCompanyWall } from "@solvari/translations";

const props = defineProps<{
  portfolio: App.Data.CompanyWallPortfolio;
}>();

const { tr } = useI18nMainSiteCompanyWall();

const panelValues = {
  projects: "projects",
  video: "video",
} as const;

const initialValue = () => {
  if (props.portfolio.projects.length) {
    return panelValues.projects;
  }
  if (props.portfolio.video) {
    return panelValues.video;
  }
  return "";
};

const value = ref(initialValue());

const totalAlbumImages = computed(() => {
  return props.portfolio.projects.reduce(
    (total, album) => total + album.count,
    0,
  );
});
</script>

<style lang="postcss">
.s-company-wall-details-portfolio {
  &__video {
    @apply grid grid-cols-2 gap-6;

    &__video {
      @apply relative z-10 h-32 w-56 rounded;

      @screen 700 {
        @apply h-56 w-full;
      }

      img {
        @apply h-full w-full cursor-pointer rounded object-cover;
      }

      &__icon {
        @apply absolute top-0 h-full w-full;
        &__container {
          @apply flex h-full items-center justify-center;
          &__circle {
            @apply flex size-14 items-center justify-center rounded-full bg-primary-700;
            i {
              @apply text-2xl text-white;
            }
          }
        }
      }
    }

    &__content {
      @apply hidden;

      @screen 700 {
        @apply block;
      }
      &__title {
        @apply text-xl font-bold text-primary-700;
      }
      &__description {
        @apply mt-2 text-gray-700;
      }
    }
  }

  .p-tabpanels {
    @apply px-0;
  }
}
</style>
